import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbDatepickerModule, NgbPopoverModule, NgbTimepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-date-time-picker',
  templateUrl: './date-time-picker.component.html',
  styleUrls: ['./date-time-picker.component.scss'],
  standalone: true,
  imports: [
    NgbTimepickerModule,
    FormsModule,
    NgbPopoverModule,
    NgbDatepickerModule,
    TranslateModule
  ]
})
export class DateTimePickerComponent implements OnInit {
  @Input() formItem: any;
  @Input() classDate?: string;
  date: any;
  time: any;
  _value: any;
  label: any;
  @Output() onDateChange: EventEmitter<any> = new EventEmitter<any>();
  constructor(private datePipe: DatePipe) { }

  ngOnInit(): void {
    this.setDateTime()
  }


  setDateTime() {
    let value = null;
    if (this.formItem?.defaultValue) {
      this.time = {
        hour: this.formItem.defaultValue.hours ?? 0,
        minute: this.formItem.defaultValue.min ?? 0,
        second: this.formItem.defaultValue.sec ?? 0
      }
      this.date = { year: this.formItem.defaultValue.year, month: this.formItem.defaultValue.month, day: this.formItem.defaultValue.day }
      value = new Date(
        this.formItem.defaultValue.year,
        this.formItem.defaultValue.month - 1,
        this.formItem.defaultValue.day,
        this.formItem.defaultValue.hours ? this.formItem.defaultValue.hours : 0,
        this.formItem.defaultValue.min ? this.formItem.defaultValue.min : 0,
        this.formItem.defaultValue.sec ? this.formItem.defaultValue.sec : 0,
      );
      value = this.datePipe.transform(value, 'yyyy-MM-dd HH:mm:ss')
    } else {
      this.date = {
        day: new Date().getDate(),
        month: new Date().getMonth() + 1,
        year: new Date().getFullYear(),

      }
      this.time = {
        hour: new Date().getHours(),
        minute: new Date().getMinutes(),
        second: new Date().getSeconds()
      }
      value = new Date(
        this.date.year,
        this.date.month - 1,
        this.date.day,
        this.time.hour,
        this.time.minute,
        this.time.second,
      )
      value = this.datePipe.transform(value, 'yyyy-MM-dd HH:mm:ss')
    }
    this._value = value;
    this.onDateChange.emit(this._value)
  }
  // dateTimePicker 
  getDatetime() {
    let value = null;
    if (!value) {
      value = new Date(
        this.date.year,
        this.date.month - 1,
        this.date.day,
        this.time.hour ? this.time.hour : 0,
        this.time.minute ? this.time.minute : 0,
        this.time.second ? this.time.second : 0,
      );
      value = this.datePipe.transform(value, 'yyyy-MM-dd HH:mm:ss');
      this._value = value;
    } else {
      this._value = value;
    }
    this.onDateChange.emit(this._value)
  }

}
